import { render } from "./EscudoBoromirView.vue?vue&type=template&id=cd63a67c"
import script from "./EscudoBoromirView.vue?vue&type=script&lang=js"
export * from "./EscudoBoromirView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__